<mat-card class="mag" style="width: max-content; box-sizing: border-box; max-width: calc(100% - 40px);">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Organization Management</mat-card-title>
                <mat-card-subtitle>Manage Registrations & View Active Hospitals</mat-card-subtitle>
            </div>

        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <!-- TABS -->
        <mat-tab-group animationDuration="0ms">

            <!-- TAB 1: PENDING APPROVALS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="g-just-flex gap-8 align-center">
                        <mat-icon class="tab-icon">hourglass_empty</mat-icon>
                        <span>Pending Requests</span>
                        @if(pendingData.length > 0) {
                            <span class="badge-count">{{pendingData.length}}</span>
                        }
                    </div>
                </ng-template>

                <div class="my-20">
                    @if(pendingData.length === 0){
                         <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center; padding: 40px; background: #f5f5f5; border-radius: 8px;">
                            <mat-icon class="icon" style="font-size: 3rem; color: #bdbdbd;">check_circle</mat-icon>
                            <span class="subtitle-text-color-2">No pending registrations found. All caught up!</span>
                        </div>
                    }@else {
                        <app-table-header 
                            [patientsTableFilterArray]="tableFilter"
                            [patientsFiltersFormControlObject]="tableFilterFormControlObject" 
                            [searchableFields]="searchableFields"
                            [selectedSearchField]="selectedSearchField"
                            (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
                        </app-table-header>
                        <table mat-table [dataSource]="pendingDataSource" class="mat-elevation-z8 demo-table">

                            <!-- Date -->
                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef> Submitted </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="g-just-flex flex-column">
                                        <span style="font-weight: 500;">{{element.submittedAt | date:'mediumDate'}}</span>
                                        <span class="subtitle-text-color-2" style="font-size: 0.8rem;">{{element.submittedAt | date:'shortTime'}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Organization Name -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Organization </th>
                                <td mat-cell *matCellDef="let element">
                                    <strong>{{element.organizationName | titlecase}}</strong>
                                </td>
                            </ng-container>

                            <!-- Admin Info -->
                            <ng-container matColumnDef="admin">
                                <th mat-header-cell *matHeaderCellDef> Administrator </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="g-just-flex flex-column">
                                        <span>{{element.adminFirstName}} {{element.adminLastName}}</span>
                                        <a href="mailto:{{element.adminEmail}}" class="subtitle-text-color-2" style="font-size: 0.85rem; text-decoration: none;">
                                            {{element.adminEmail}}
                                        </a>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Admin Contact -->
                            <ng-container matColumnDef="contact">
                                <th mat-header-cell *matHeaderCellDef> Contact </th>
                                <td mat-cell *matCellDef="let element"> {{element.adminPhone}} </td>
                            </ng-container>

                            <!-- Action -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef> Action </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                                   <button mat-flat-button color="primary" class="small-button"
                                      (click)="viewPendingDetails(element)"
                                      matTooltip="View Details & Review">
                                      <mat-icon>visibility</mat-icon> View Details
                                  </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="pendingColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: pendingColumns;"></tr>
                        </table>
                        <mat-paginator #pendingPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    }
                </div>
            </mat-tab>

            <!-- TAB 2: ACTIVE ORGANIZATIONS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="g-just-flex gap-8 align-center">
                        <mat-icon class="tab-icon">domain</mat-icon>
                        <span>Organizations</span>
                    </div>
                </ng-template>

                <div class="my-20">
                    @if(approvedData.length === 0){
                        <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center; padding: 40px; background: #f5f5f5; border-radius: 8px;">
                            <span class="subtitle-text-color-2">No active organizations found.</span>
                        </div>
                    }@else {
                        <app-table-header 
                            [patientsTableFilterArray]="tableFilter"
                            [patientsFiltersFormControlObject]="tableFilterFormControlObject" 
                            [searchableFields]="searchableFields"
                            [selectedSearchField]="selectedSearchField"
                            (searchCriteriaChanged)="onApprovedSearchCriteriaChanged($event)">
                        </app-table-header>
                        {{ approvedData.length }}
                        <table mat-table [dataSource]="approvedDataSource" class="mat-elevation-z8 demo-table">

                        <!-- Name -->
                       <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Organization Name </th>
    <td mat-cell *matCellDef="let element">
        <div class="g-just-flex gap-8 align-center">
            <span style="font-weight: 500;"> {{ element.name }} </span>
            <!-- ✅ Parent Organization Badge -->
            @if(isParentOrganization(element)) {
                <span class="parent-org-badge" matTooltip="This is the main parent organization">
                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;">star</mat-icon>
                    Parent Org
                </span>
            }
        </div>
    </td>
</ng-container>

                        <!-- Type -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef> Category </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="small-chips status-blue g-just-flex gap-8" style="width: fit-content;">
                                    <span>{{ element.type }}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Contact -->
                        <ng-container matColumnDef="contact">
                            <th mat-header-cell *matHeaderCellDef> Primary Contact </th>
                            <td mat-cell *matCellDef="let element"> {{ element.contact }} </td>
                        </ng-container>

                        <!-- Address -->


                        <!-- Status -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                @if(isActive(element)) {
                                    <div class="small-chips status-green g-just-flex gap-8" style="width: fit-content;">
                                        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
                                        <span>Active</span>
                                    </div>
                                } @else {
                                    <div class="small-chips status-grey g-just-flex gap-8" style="width: fit-content;">
                                        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">block</mat-icon>
                                        <span>Inactive</span>
                                    </div>
                                }
                            </td>
                        </ng-container>

                        <!-- Action -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Actions">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="viewApprovedDetails(element.raw)">
                                        <mat-icon>visibility</mat-icon>
                                        <span>View Details</span>
                                    </button>
                                    @if(isActive(element)) {
                                      @if(!isParentOrganization(element)) {
                                        <button mat-menu-item (click)="onDeactivate(element)">
                                            <mat-icon>block</mat-icon>
                                            <span>Deactivate</span>
                                        </button>}
                                    } @else {
                                        <button mat-menu-item (click)="onReactivate(element)">
                                            <mat-icon color="primary">refresh</mat-icon>
                                            <span>Reactivate</span>
                                        </button>
                                    }
                                </mat-menu>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="approvedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: approvedColumns;"></tr>
                    </table>
                    <mat-paginator #approvedPaginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    }
                </div>
            </mat-tab>

            <!-- TAB 3: ARCHIVED ORGANIZATIONS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="g-just-flex gap-8 align-center">
                        <mat-icon class="tab-icon">archive</mat-icon>
                        <span>Archived</span>
                        @if(archivedData.length > 0) {
                            <span class="badge-count">{{archivedData.length}}</span>
                        }
                    </div>
                </ng-template>

                <div class="my-20">
                    @if(archivedData.length === 0){
                         <div class="g-just-flex flex-column gap-15" style="align-items: center; justify-content: center; padding: 40px; background: #f5f5f5; border-radius: 8px;">
                            <mat-icon class="icon" style="font-size: 3rem; color: #bdbdbd;">archive</mat-icon>
                            <span class="subtitle-text-color-2">No archived organizations found.</span>
                        </div>
                    }@else {
                        <app-table-header 
                            [patientsTableFilterArray]="tableFilter"
                            [patientsFiltersFormControlObject]="tableFilterFormControlObject" 
                            [searchableFields]="searchableFields"
                            [selectedSearchField]="selectedSearchField"
                            (searchCriteriaChanged)="onArchivedSearchCriteriaChanged($event)">
                        </app-table-header>
                        <table mat-table [dataSource]="archivedDataSource" class="mat-elevation-z8 demo-table">

                            <!-- Organization Name -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Organization Name </th>
                                <td mat-cell *matCellDef="let element">
                                    <strong>{{element.organizationName}}</strong>
                                </td>
                            </ng-container>

                            <!-- Type -->
                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef> Category </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="small-chips status-grey g-just-flex gap-8" style="width: fit-content;">
                                        <span>{{ getType(element.rawFhir) }}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Reviewed At -->
                            <ng-container matColumnDef="reviewedAt">
                                <th mat-header-cell *matHeaderCellDef> Archived Date </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="g-just-flex flex-column">
                                        <span style="font-weight: 500;">{{element.reviewedAt | date:'mediumDate'}}</span>
                                        <span class="subtitle-text-color-2" style="font-size: 0.8rem;">{{element.reviewedAt | date:'shortTime'}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Reviewed By -->
                            <ng-container matColumnDef="archivedBy">
                                <th mat-header-cell *matHeaderCellDef> Archived By </th>
                                <td mat-cell *matCellDef="let element">
                                    <span>{{element.archivedBy || 'System'}}</span>
                                </td>
                            </ng-container>
                            <!-- Action -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef> Action </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                                    <button mat-icon-button [matMenuTriggerFor]="archiveMenu" matTooltip="Actions">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #archiveMenu="matMenu">
                                        <button mat-menu-item (click)="viewArchivedDetails(element)">
                                            <mat-icon>visibility</mat-icon>
                                            <span>View Details</span>
                                        </button>
                                        <button mat-menu-item (click)="onReactivate(element)">
                                            <mat-icon color="primary">unarchive</mat-icon>
                                            <span>Restore</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="archivedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: archivedColumns;"></tr>
                    </table>
                    <mat-paginator #archivedPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    }
                </div>
            </mat-tab>

        </mat-tab-group>
    </mat-card-content>
</mat-card>



